/* global google, gmapAcfFields, agFeatures_agGmap */
const $body = $(document.body);

const initAccordion = ($accordion = $('.accordion')) => {
  console.log('initAccordion');

  const main = () => {
    console.log('accordion.main fired')
    $accordion.collapse()
  }

  if($body.hasClass('wp-admin')){
    //delay main execution in wp-admin
    $body.on('ag.accordion.ready', main);
  } else {
    // for accordion we also run the main
    // as it will open the first card
    main();
  }
};

window.initAccordion = initAccordion;

export default initAccordion;
